export default "__VITE_ASSET__dpQWaFJc__"